import { useHandler } from "@redotech/react-util/hook";
import {
  getMatchTypeLabel,
  StringToListMatchType,
} from "@redotech/redo-model/advanced-flow/common/condition";
import { OmsConditionType } from "@redotech/redo-model/advanced-flow/oms/conditions";
import { OmsConditionStep } from "@redotech/redo-model/advanced-flow/steps";
import { RedoListItem } from "@redotech/redo-web/arbiter-components/list/redo-list";
import { RedoSingleSelectDropdownInput } from "@redotech/redo-web/arbiter-components/select-dropdown/redo-single-select-dropdown-input";
import { memo } from "react";
import { DeepPartial } from "..";

const stringToListMatchTypeOptions: RedoListItem<StringToListMatchType>[] =
  Object.values(StringToListMatchType).map((type) => ({
    value: type,
    type: "text",
    id: type,
    text: getMatchTypeLabel(type, false),
  }));

export const StringToListMatchTypeSelect = memo(
  function StringToListMatchTypeSelect({
    step,
    setStep,
  }: {
    step: DeepPartial<OmsConditionStep>;
    setStep: (step: DeepPartial<OmsConditionStep>) => void;
  }) {
    // Dynamic check - we only handle these specific condition types
    if (
      step.conditionType !== OmsConditionType.DESTINATION_PROVINCE &&
      step.conditionType !== OmsConditionType.DESTINATION_COUNTRY &&
      step.conditionType !== OmsConditionType.DELIVERY_METHOD &&
      step.conditionType !== OmsConditionType.SALES_CHANNEL &&
      step.conditionType !== OmsConditionType.FULFILLMENT_LOCATION &&
      step.conditionType !== OmsConditionType.ORIGIN_STORE &&
      step.conditionType !== OmsConditionType.STREET_ADDRESS_LIST_INPUT &&
      step.conditionType !== OmsConditionType.MARKETPLACE &&
      step.conditionType !== OmsConditionType.CUSTOM_STRING_1 &&
      step.conditionType !== OmsConditionType.CUSTOM_STRING_2 &&
      step.conditionType !== OmsConditionType.CUSTOM_STRING_3 &&
      step.conditionType !== OmsConditionType.CUSTOM_ATTRIBUTE_STRING_1 &&
      step.conditionType !== OmsConditionType.CUSTOM_ATTRIBUTE_STRING_2 &&
      step.conditionType !== OmsConditionType.CUSTOM_ATTRIBUTE_STRING_3 &&
      step.conditionType !== OmsConditionType.CUSTOMER_NAME &&
      step.conditionType !== OmsConditionType.USPS_ZONE &&
      step.conditionType !== OmsConditionType.LINE_ITEM_CUSTOM_ATTRIBUTE
    ) {
      throw new Error(
        `Unsupported condition type in StringToListMatchTypeSelect: ${step.conditionType}`,
      );
    }
    const setMatchType = useHandler(
      ({
        item: matchTypeListItem,
      }: {
        item: RedoListItem<StringToListMatchType>;
      }) => {
        setStep({ ...step, matchType: matchTypeListItem.value });
      },
    );
    return (
      <RedoSingleSelectDropdownInput<StringToListMatchType>
        fitToAnchor={false}
        flexGrow={false}
        options={stringToListMatchTypeOptions}
        optionSelected={setMatchType}
        placeholder="Select a criteria"
        selectedItem={stringToListMatchTypeOptions.find(
          (o) => o.id === step.matchType,
        )}
        size="xs"
      />
    );
  },
);
